var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"action-card",class:`action-card--${_vm.view}`},[_c('div',{staticClass:"action-card__content"},[_c('h3',{staticClass:"action-card__title"},[_vm._t("title")],2),_c('div',{staticClass:"action-card__body"},[_vm._t("default")],2)]),_vm._t("btn")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }